import styled from 'styled-components';

import { Box, Typography, Tooltip } from '@mui/material';

import { colors } from '../../theme';
import moment from 'moment';
import { MOMENT_TIME_DISPLAY_FORMAT_24_HRS, MOMENT_TIME_FORMAT } from '../../constants/date_format';

const ScheduleGrid = (props: any) => {
    const { roomNumber, roomSchedule, roomComments } = props;

    const maxCharacters = 23;

    const displayLongComments = roomComments?.length > maxCharacters;

    return (
        <>
            <Container>
                <FlexBox sx={{ alignItems: 'flex-start' }}>
                    <Box sx={{ backgroundColor: colors.navy.main, width: '45px' }}>
                        <Typography variant="h6" color={colors.white} sx={{ textAlign: 'center' }}>
                            {roomNumber}
                        </Typography>
                    </Box>
                    <Tooltip title={displayLongComments ? roomComments : ''} arrow>
                        <Typography variant="body2" sx={{ fontSize: '10px', textAlign: 'center', width: '100%' }}>
                            {roomComments?.substring(0, maxCharacters)} {displayLongComments && `...`}
                        </Typography>
                    </Tooltip>
                </FlexBox>
                <Box sx={{ p: '3px' }}>
                    {roomSchedule &&
                        roomSchedule.map((o: any, i: number) => {
                            return (
                                <FlexBox key={i} sx={{ background: o.isEvent && colors.yellow.medium }}>
                                    <Typography variant="body2" sx={{ fontSize: '11px' }}>
                                        {o.isEvent ? o.eventName.split('  ').join(' ').slice(0, 9) : o.courseSubject + ' ' + o.courseNumber}
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: '11px' }}>
                                        {moment(o.timeIn, MOMENT_TIME_FORMAT).format(MOMENT_TIME_DISPLAY_FORMAT_24_HRS)}-{moment(o.timeOut, MOMENT_TIME_FORMAT).format(MOMENT_TIME_DISPLAY_FORMAT_24_HRS)}
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: '11px' }}>
                                        {o.isEvent ? o.eventCRN : o.courseCRN}
                                    </Typography>
                                </FlexBox>
                            );
                        })}
                </Box>
            </Container>
        </>
    );
};

export default ScheduleGrid;

const Container = styled.div`
    width: 170px;
    border: 1px solid ${colors.navy.main};
    height: 105px;
    max-height: 105px;
    overflow-x: hidden;
    overflow-y: auto;
    margin-left: -1px;
    margin-top: -1px;
    z-index: 1;

    &:hover {
        cursor: default;
    }
`;

const FlexBox = styled(Box)`
    && {
        display: flex;
        justify-content: space-between;
    }
`;
